import React, { useState } from 'react';
import { Box } from '@mui/material';
import { ReactComponent as ChatBubbleIcon } from '../../../assets/chat-bubble.svg';
import GenieChat from './GenieChat';

const STORAGE_KEY = 'genie_chat_isOpen';

const GenieChatButton: React.FC = () => {
    const [isOpen, setIsOpen] = useState(() => {
        return sessionStorage.getItem(STORAGE_KEY) === 'true';
    });

    const toggleOpen = (open: boolean) => {
        setIsOpen(open);
        sessionStorage.setItem(STORAGE_KEY, String(open));
    };

    return (
        <>
            {!isOpen && (
                <Box
                    component="button"
                    id="genie-chat-button"
                    onClick={() => toggleOpen(true)}
                    aria-label="Open FinOps AI Assistant"
                    sx={{
                        position: 'fixed',
                        bottom: '24px',
                        right: '45px',
                        display: 'flex',
                        flexDirection: 'column',
                        alignItems: 'center',
                        justifyContent: 'center',
                        width: '80px',
                        height: '80px',
                        gap: '2px',
                        backgroundColor: '#003771',
                        color: '#ffffff',
                        border: 'none',
                        borderRadius: '50%',
                        padding: 0,
                        boxShadow: '0 4px 18px rgba(0, 55, 113, 0.45)',
                        cursor: 'pointer',
                        zIndex: 1100,
                        fontFamily: '"Montserrat", sans-serif',
                        fontSize: '14px',
                        fontWeight: 500,
                        lineHeight: '100%',
                        transition: 'transform 0.18s ease, box-shadow 0.18s ease, background-color 0.18s ease',
                        outline: 'none',
                        '&:hover': {
                            backgroundColor: '#004894',
                            transform: 'translateY(-2px)',
                            boxShadow: '0 8px 24px rgba(0, 55, 113, 0.5)',
                        },
                        '&:active': { transform: 'translateY(0)' },
                    }}
                >
                    <Box component="span" sx={{ fontSize: '13px' }}>Ask Me</Box>
                    <Box component="span" sx={{ display: 'flex', alignItems: 'center', justifyContent: 'center' }} aria-hidden="true">
                        <ChatBubbleIcon width={36} height={31} />
                    </Box>
                </Box>
            )}

            {isOpen && <GenieChat onClose={() => toggleOpen(false)} />}
        </>
    );
};

export default GenieChatButton;
